import { useState } from "react";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import UserDetails from "../UserDetails";
import CreditRep from "../CreditRep.Component";
import CreditHistory from "../../ApplicationDetails/CreditHistory.Component";

const ApplicationDetailTabs = ({ application, accountInfo }) => {
  const [activeTab, setActiveTab] = useState(1);

  const handleChangeTab = (event, newValue) => setActiveTab(newValue);

  const tabContentStyle = { padding: "10px" };
  const tabStyle = { margin: "5px -5px 0" };

  return (
    <div style={tabStyle}>
      <Tabs value={activeTab} onChange={handleChangeTab}>
        <Tab label="User" value={1} />
        <Tab label="Credit Rep." value={2} />
        <Tab label="History" value={3} />
      </Tabs>
      {activeTab === 1 && (
        <div style={tabContentStyle}>
          <UserDetails
            application={application}
            accountInfo={accountInfo}
            accountId={application.BorrowerId}
            hideReports={true}
          />
        </div>
      )}
      {activeTab === 2 && (
        <div style={tabContentStyle}>
          <CreditRep application={application} />
        </div>
      )}
      {activeTab === 3 && (
        <div style={tabContentStyle}>
          <CreditHistory accountId={application.BorrowerId} />
        </div>
      )}
    </div>
  );
};

export default ApplicationDetailTabs;
